export default __webpack_public_path__ + "static/media/closing-img.904c2f87.svg";